import { render } from "./Request-reset-password.vue?vue&type=template&id=b897a338&lang=pug"
import script from "./Request-reset-password.vue?vue&type=script&lang=js"
export * from "./Request-reset-password.vue?vue&type=script&lang=js"

import "./Request-reset-password.vue?vue&type=style&index=0&id=b897a338&lang=scss"

import exportComponent from "C:\\m-tech\\WMExtranet2.0\\WebUI\\WiseApp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__